@if (!isGewe) {
  <div>
    @if (validateCheckboxes && !rightOfWithdrawalAccepted) {
      <div class="error re-mb-5">
        {{ 'legal.rightsOfWithdrawalRequired' | translate }}
      </div>
    }
    <bdo-checkbox
      [checked]="rightOfWithdrawalAccepted"
      (change)="onChangeRightOfWithdrawalAccepted()"
      data-qa="rightOfWithdrawalCheckbox">
    <div [innerHTML]="'legal.rightsOfWithdrawal' | translate:
                      { linkRightsOfWithdrawal: linkRevoke }"></div>
    </bdo-checkbox>
  </div>
}

<div [ngClass]="isGewe ? 're-mt-0' : 're-mt-15'">
  @if (validateCheckboxes && !termsOfConditionsAccepted) {
    <div class="error re-mb-5">
      {{ 'legal.termsOfConditionRequired' | translate }}
    </div>
  }
  <bdo-checkbox
    [checked]="termsOfConditionsAccepted"
    (change)="onChangeTermsOfConditions()"
    data-qa="termsOfConditionsCheckbox">
    <div [innerHTML]="stringContractTerms"></div>
  </bdo-checkbox>
</div>

@if (communicationAccepted !== null) {
  @if (isDynamic) {
    <div class="re-mt-15">
      @if (validateCheckboxes && !dynamicConditionsAccepted) {
        <div class="error re-mb-5">
          {{ 'legal.dynamicRequired' | translate }}
        </div>
      }
      <bdo-checkbox
        [checked]="dynamicConditionsAccepted"
        (change)="onChangeDynamicConditionsAccepted(!dynamicConditionsAccepted)"
        data-qa="dynamicConditionsAcceptedCheckbox">
        <div [innerHTML]="'legal.dynamic' | translate: { hrefSmartMeter: reBaseData.hrefSmartMeter }"></div>
      </bdo-checkbox>
    </div>
  }


  <div class="re-mt-15">
    <bdo-checkbox
      [checked]="communicationAccepted"
      (change)="onChangeCommunicationAccepted(!communicationAccepted)"
      data-qa="communicationAcceptedCheckbox">
      <div [innerHTML]="'legal.accepted' | translate:
                        { companyName: reBaseData.companyName }"></div>
      </bdo-checkbox>
  </div>
}

<div class="re-summary-row re-mb-0 re-mt-30"
     [innerHTML]="'legal.privacyInfo' | translate:
                  { linkPrivacy: linkPrivacy }">
</div>
